import { Directive, ElementRef, EventEmitter, HostListener, Inject, Output, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Directive({
    standalone: false,
    selector: '[clickOutside]'
})
export class ClickOutsideDirective {
    constructor(
        private _elementRef: ElementRef,
        @Inject(PLATFORM_ID) private platformId: object
    ) {}

    @Output()
    public clickOutside = new EventEmitter<void>();

    @HostListener('document:click', ['$event.target'])
    public onClick(targetElement: any) {
        if (!isPlatformBrowser(this.platformId)) {
            return;
        }

        const clickedInside = this._elementRef.nativeElement.contains(targetElement);
        if (!clickedInside) {
            this.clickOutside.emit();
        }
    }
}
